import { numberToENG } from "tools/functions/Methods"

export function createParams(data) {
  const params = {
    hubId: data?.id?.hubId,
    validFromDay: data?.id.validFrom.day,
    validFromMonth: data?.id.validFrom.month,
    validFromYear: data?.id.validFrom.year,
  }

  const queryString = new URLSearchParams(params as any).toString()

  return queryString
}


export function filterType(option){
    return option
  //  return option.filter(item=>[1,0].includes(item.id))
}



const todayFa = new Date().toLocaleDateString("fa-IR").split("/")

export const firstDayOfMonth = {
  year: Number(numberToENG(todayFa[0])),
  month: Number(numberToENG(todayFa[1])),
  day: 1,
}